import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { formatCompactCurrency, formatCurrency } from '../InvoiceMetricsSection.utils';
import { MetricsCard } from '../MetricsCard/MetricsCard';
import styles from './NumberOnlyCard.module.scss';
export const GetNumberOnlyCardTID = (parentTestId)=>getTestIds(parentTestId);
export const NumberOnlyCard = (param)=>{
    let { title, tooltip, amount, count, emptyPrimary, emptySubtitle, isActive = false, isEditMode = false, isLoading = false, isRefetching = false, onRemove, dragHandle, onClick, testId } = param;
    const { NumberOnlyCardTestIds } = useMemo(()=>GetNumberOnlyCardTID(testId), [
        testId
    ]);
    const { t: invoiceMetricsSectionTexts } = useLocaleKeys('components.invoiceMetricsSection');
    const isEmpty = count === 0;
    const primaryText = isEmpty ? emptyPrimary : formatCompactCurrency(amount);
    const subtitleText = isEmpty ? emptySubtitle : invoiceMetricsSectionTexts.invoicesCount({
        count
    });
    const isAbbreviated = !isEmpty && Math.abs(amount) >= 1000000;
    const fullAmountText = isAbbreviated ? formatCurrency(amount) : undefined;
    return /*#__PURE__*/ _jsx(MetricsCard, {
        title: title,
        tooltip: tooltip,
        isActive: isActive,
        isDisabled: isEmpty,
        isEditMode: isEditMode,
        isLoading: isLoading,
        isRefetching: isRefetching,
        onRemove: onRemove,
        dragHandle: dragHandle,
        onClick: onClick,
        testId: NumberOnlyCardTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Box, {
            className: styles.body,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    weight: "normal",
                    testId: NumberOnlyCardTestIds.PrimaryValue(),
                    className: styles.primaryValue,
                    title: fullAmountText,
                    children: primaryText
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    skin: "secondary",
                    testId: NumberOnlyCardTestIds.Subtitle(),
                    className: styles.subtitle,
                    children: subtitleText
                })
            ]
        })
    });
};
